import axios, {AxiosError} from 'axios';

interface ApiErrorResponseProps {
  errors: {
    [key: string]: string;
  };
}

export default (error: any) => {
  if (axios.isAxiosError(error)) {
    if ((error.response?.data as ApiErrorResponseProps).errors)
      return Object.values(
        (error.response?.data as ApiErrorResponseProps).errors,
      )[0];

    return (error as any).response?.data?.message ?? error.message;
    // const data = (error as AxiosError).response?.data as any;

    // if (data.message) return data.message;
    // if (data.messages) return Object.values(data.messages[0])[0];
  }

  return error;
};
